/* template */
<template minapp="mpx" xlang="wxml"><div class="falling-popup-container"><es-popup :show="(fallingSwitch)" @close="closeFalling"><div class="panel-container-up"><div class="panel-header"><mpx-image mode="widthFix" :src="(headerImage)" class="panel-header-image"/></div><div :style="[(panelContentStyle)] | transRpxStyle" class="panel-content"><coupon-list :listData="(listData)" :couponTheme="(couponTheme)"/></div><div class="vague" v-if="(listData.length>2)"></div></div><div class="panel-container-down"><div class="panel-footer"><coupon-btn :buttonTheme="(buttonTheme)" @receiveFallingCoupon="receiveFallingCoupon"/></div></div><mpx-image @tap="closeFalling" :src="(closeIcon)" class="close-icon"/></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mba71be32"}'>
  .panel-container-up
    width 260px
    max-height 300px
    border-radius 15px
    position relative
    overflow hidden
    background linear-gradient(169deg, #FF8935 7%, #FF6935 85%)
    .panel-header
      height 80px
      .panel-header-image
        width 100%
        height 100%
    .vague
      height 24px
      position absolute
      bottom 0
      left 0
      width 100%
      background linear-gradient(180deg, rgba(254, 117, 53, 0) 0%, #FE7535 36%)
      z-index 1
    .panel-content
      max-height 190px
      overflow-y auto
      border-radius 24px 24px 0 0
    .panel-footer
      height 70px
      display flex
      justify-content center
      align-items center
      overflow hidden
  .panel-container-down
    width 260px
    height 69px
    border-radius 15px
    background: #FF6935;
    position relative
    overflow hidden
    display flex
    justify-content center
    margin-top -1px
    .panel-footer
      height 45px
      margin-top 5px
      display flex
      justify-content center
      align-items center
      overflow hidden
  .close-icon
    width 36px
    height 36px
    margin 20px auto 0 
    display block
  .falling-image-flights-activity
    width 300px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mba71be32"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexba71be32%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexba71be32%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mba71be32"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexba71be32/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-popup':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'coupon-btn':getComponent(require("./coupon-btn.mpx?isComponent&outputPath=components%2Fcoupon-btn4fc1e5ee%2Findex")),'coupon-list':getComponent(require("./coupon-list.mpx?isComponent&outputPath=components%2Fcoupon-list7da805fa%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
